import { FEATURES } from '/src/features/_global/constants';

export const HOME_PERMISSIONS = {
  [FEATURES.HOME]: ({ capabilities }) => ({
    navigate: capabilities?.home.permissions.nav,
    view: capabilities?.home.permissions.view,
  }),
};
